<template>
  <NuxtLink to="/newsletter" target="_blank" class="newsletter-button">
    <BaseNuxtImage
      width="120"
      height="120"
      class="newsletter-button__image"
      alt="Illustration of a pigeon holding a letter"
      src="https://a.storyblok.com/f/120667/410x410/fc93bfd0ce/thank-you-pigeon-2x.png"
    />
    <div class="newsletter-button__content">
      <h4 class="newsletter-button__title">
        Get the latest news from Infermedica
      </h4>
      <p class="newsletter-button__link">Subscribe to our newsletter →</p>
    </div>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.newsletter-button {
  $root: &;

  display: flex;
  flex-direction: column;
  gap: 32px;
  cursor: pointer;
  padding: 48px;
  align-items: flex-start;
  color: var(--color-text);
  text-decoration: none;
  border: 1px solid var(--gray-300);
  border-radius: 16px;

  @media (min-width: $breakpoint-md) {
    flex-direction: row;
  }

  &__image {
    width: 100%;
    max-width: 120px;
    height: auto;
    border-radius: var(--border-radius-small);
  }

  &__text {
    @include paragraph-s;

    margin-bottom: 8px;
  }

  &__content {
    flex-grow: 1;
  }

  &__title {
    margin-bottom: 8px;
  }

  &__description {
    margin-bottom: 8px;
  }

  &__link {
    margin: 0;
    color: var(--color-link);
  }

  &:hover {
    #{$root}__link {
      text-decoration: underline;
    }

    #{$root}__title {
      color: var(--color-link);
    }
  }
}
</style>
